module.exports = __webpack_public_path__ + "img/health26_7-9-2021.10c151c5.jpg";